import React from 'react';
import io from 'socket.io-client';
const API_ENDPOINT =
  process.env.NODE_ENV === 'production'
    ? process.env.REACT_APP_API_ENDPOINT_PROD
    : process.env.REACT_APP_API_ENDPOINT_DEV;
export const socket = io();
export const SocketContext = React.createContext();
